import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-h2-adapting-size',
  templateUrl: './h2-adapting-size.component.html',
  styleUrls: ['./h2-adapting-size.component.css']
})
export class H2AdaptingSizeComponent implements OnInit {

  @Input()
  text: string;

  constructor() { }

  ngOnInit() {
  }

  getClass(text: string): string {
    return text && text.length > 12 ? 'fontSizeTitle' : '';
  }

}
